//
// Module for the Payment Options Edit view
//
rs.module("system/configuration/paymentoptions/edit",

    ["common/select-helper", "common/visibility"],

    function (selectHelper, visibility) {

        // Initialize the module
        function initialize(jsSelectors, paymentOptionMethodCodeValues, formAdjustmentMethodCodeValues, termTypeEnum) {
            var form = $.js(jsSelectors.paymentOptionForm);

            var paymentOptionMethodSelect = form.js(jsSelectors.paymentOptionMethodSelect);

            var termType = form.js(jsSelectors.termType);
            var termSelect = termType.js(jsSelectors.termSelect);
            var termSelectHelper = selectHelper.getHelper(termSelect);
            var numberOfPayments = form.js(jsSelectors.numberOfPayments);
            var numberOfYears = form.js(jsSelectors.numberOfYears);
            var paymentOptionPercent = form.js(jsSelectors.paymentOptionPercent);
            var variableFlag = form.js(jsSelectors.variableFlag);
            var variableCheckBox = $(variableFlag).children('input[type="checkbox"]');

            var formAdjustmentMethodSelect = form.js(jsSelectors.formAdjustmentMethodSelect);

            var actuarialAssumption = form.js(jsSelectors.actuarialAssumption);
            var actuarialAssumptionSelectHelper = selectHelper.getHelper($(actuarialAssumption).children('select'));
            var lookUpTable = form.js(jsSelectors.lookUpTable);
            var lookUpTableSelectHelper = selectHelper.getHelper($(lookUpTable).children('select'));
            var flatPercentage = form.js(jsSelectors.flatPercentage);

            // Display appropriate paymentOptionMethod fields based on selection
            paymentOptionMethodSelect.change(function () {
                ResetPaymentOptionMethodFields();
                ShowPaymentOptionMethodFields(paymentOptionMethodSelect.val());
                DefaultPaymentOptionMethodFields(paymentOptionMethodSelect.val());
            });

            // Display appropriate years/payments input based on selection
            termSelect.change(function () {
                ClearInput(numberOfPayments);
                ClearInput(numberOfYears);

                if (termSelect.val() == termTypeEnum.Years) {
                    visibility.hide(numberOfPayments);
                    visibility.show(numberOfYears);
                } else {
                    visibility.show(numberOfPayments);
                    visibility.hide(numberOfYears);
                }

                DefaultPaymentOptionMethodFields(paymentOptionMethodSelect.val());
            });

            // Remove validation messages and clear the corresponding fields if checked
            variableCheckBox.change(function () {
                if (this.checked) {
                    ClearInput(numberOfPayments);
                    ClearInput(numberOfYears);
                    ClearInput(paymentOptionPercent);

                    DefaultPaymentOptionMethodFields(paymentOptionMethodSelect.val());
                }
            });

            // Display appropriate formAdjustmentMethod fields based on selection
            formAdjustmentMethodSelect.change(function () {
                ResetFormAdjustmentMethodFields();
                ShowFormAdjustmentMethodFields(formAdjustmentMethodSelect.val());
            });

            // Remove validation messages, clear, and hide all the paymentOptionMethod fields
            function ResetPaymentOptionMethodFields() {
                termSelectHelper.selectIndex(0);
                ClearInput(numberOfPayments);
                ClearInput(numberOfYears);
                ClearInput(paymentOptionPercent);
                variableCheckBox.prop('checked', false);

                visibility.hide(termType);
                visibility.hide(numberOfPayments);
                visibility.hide(numberOfYears);
                visibility.hide(paymentOptionPercent);
                visibility.hide(variableFlag);
            }

            // Clear input and remove validation message of the input inside the given form-group
            function ClearInput(formGroupDiv) {
                $(formGroupDiv).children('input').val('').clearErrors();
            }

            // Set the value to 0
            function DefaultValue(formGroupDiv) {
                $(formGroupDiv).children('input').val('0');
            }

            // Display the corresponding controls to the given paymentOptionMethod
            function ShowPaymentOptionMethodFields(methodCodeKey) {
                switch (parseInt(methodCodeKey)) {
                    case paymentOptionMethodCodeValues.certainAndLife:
                        visibility.show(numberOfYears);
                        visibility.show(variableFlag);
                        break;

                    case paymentOptionMethodCodeValues.contingentJointAndSurvivor:
                    case paymentOptionMethodCodeValues.jointAndSurvivorPopUp:
                    case paymentOptionMethodCodeValues.trueJointAndSurvivor:
                        visibility.show(paymentOptionPercent);
                        visibility.show(variableFlag);
                        break;

                    case paymentOptionMethodCodeValues.term:
                        visibility.show(termType);
                        // term defaults to years
                        visibility.show(numberOfYears);
                        visibility.show(variableFlag);
                        break;
                }
            }

            // Default the inputs to 0
            function DefaultPaymentOptionMethodFields(methodCodeKey) {
                switch (parseInt(methodCodeKey)) {
                    case paymentOptionMethodCodeValues.certainAndLife:
                        DefaultValue(numberOfYears);
                        break;

                    case paymentOptionMethodCodeValues.contingentJointAndSurvivor:
                    case paymentOptionMethodCodeValues.jointAndSurvivorPopUp:
                    case paymentOptionMethodCodeValues.trueJointAndSurvivor:
                        DefaultValue(paymentOptionPercent);
                        break;

                    case paymentOptionMethodCodeValues.term:
                        if (termSelect.val() == termTypeEnum.Years) {
                            DefaultValue(numberOfYears);
                        } else {
                            DefaultValue(numberOfPayments);
                        }
                        break;
                }
            }

            // Clear and hide all the formAdjustmentMethod fields
            function ResetFormAdjustmentMethodFields() {
                actuarialAssumptionSelectHelper.selectIndex(0);
                lookUpTableSelectHelper.selectIndex(0);
                ClearInput(flatPercentage);

                visibility.hide(actuarialAssumption);
                visibility.hide(lookUpTable);
                visibility.hide(flatPercentage);
            }

            // Display the corresponding controls to the given formAdjustmentMethod
            function ShowFormAdjustmentMethodFields(methodCodeKey) {
                switch (parseInt(methodCodeKey)) {
                    case formAdjustmentMethodCodeValues.actuarialAssumptions:
                        visibility.show(actuarialAssumption);
                        break;
                    case formAdjustmentMethodCodeValues.flatPercentageFactor:
                        visibility.show(flatPercentage);
                        break;
                    case formAdjustmentMethodCodeValues.lookUpTable:
                        visibility.show(lookUpTable);
                        break;
                }
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);